import { type CSSProperties, type ReactElement } from 'react';

import { percent } from '@web/molecules/StatsBarChart/StatsBarChart.utils';
import styles from '@web/molecules/StatsPiechart/StatsPiechart.module.scss';

export interface Props {
    title: string | ReactElement;
    primaryValue: number;
    secondaryValue: number;
}

export const StatsPiechart = ({ title, primaryValue = 0, secondaryValue = 0 }: Props) => {
    const total = primaryValue + secondaryValue;
    const cssChartVariables = {
        '--cmp-stats-pie-chart-right-percentage': `${percent(secondaryValue, total)}%`,
        '--cmp-stats-pie-chart-left-percentage': `${percent(primaryValue, total)}%`,
    } as CSSProperties;

    return (
        <dl className={styles.StatsPiechart}>
            <dt>{title}</dt>
            <dd>
                <span className={styles.percentage}>{primaryValue}%</span>
                <span
                    className={`${styles.pie} ${primaryValue > secondaryValue ? styles.flip : ''}`}
                    style={cssChartVariables}
                ></span>
                <span className={styles.percentage}>{secondaryValue}%</span>
            </dd>
        </dl>
    );
};
